import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ControlPanelSteps } from '@upstart/harmony/lib/flow-utils';
import AvailableListItem from './AvailableListItem';

class AvailableList extends Component {
  getAvailableSteps = () => {
    const { flow, flowListType } = this.props;
    const allSteps = Object.values(ControlPanelSteps[flowListType]);
    const currentSteps = (flow || []).map(e => e.id);
    return allSteps
      .filter(s => !currentSteps.includes(s.id))
      .filter(s => !this.props.disabledSteps.includes(s.id));
  };

  renderStep = (item, index) => {
    const { flowListType } = this.props;
    return (
      <AvailableListItem
        flowListType={flowListType}
        key={index}
        item={item}
        flow={this.props.flow}
        onChange={this.props.onChange}
      />
    );
  };

  renderEmptyList = () => (
    <div className="available-list-empty">No additional steps available</div>
  );

  render() {
    const steps = this.getAvailableSteps();
    return (
      <div className="available-list-container">
        <div className="available-list-title">Available flow steps</div>
        {steps.length ? steps.map(this.renderStep) : this.renderEmptyList()}
      </div>
    );
  }
}

AvailableList.propTypes = {
  flow: PropTypes.array,
  flowListType: PropTypes.string,
  onChange: PropTypes.func,
  disabledSteps: PropTypes.array,
};

export default AvailableList;
